import script from "./ListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ListView.vue?vue&type=script&setup=true&lang=js"

import "./ListView.vue?vue&type=style&index=0&id=c2b5a024&lang=css"

const __exports__ = script;

export default __exports__